import { render, staticRenderFns } from "./WalkingCustomerRateCard.vue?vue&type=template&id=15f52004&scoped=true&"
import script from "./WalkingCustomerRateCard.vue?vue&type=script&lang=js&"
export * from "./WalkingCustomerRateCard.vue?vue&type=script&lang=js&"
import style0 from "./WalkingCustomerRateCard.vue?vue&type=style&index=0&id=15f52004&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f52004",
  null
  
)

export default component.exports